import { UNAUTHORIZED_USER } from '../../constants';
import type { UserId } from '../../types';
import { isAuthorizedUserId } from './isAuthorizedUserId';

export const normalizeUserId = (userId: UserId): string => {
    return isAuthorizedUserId(userId) ? String(userId) : UNAUTHORIZED_USER;
};
